import { SWMS_SHIFT_PRE_START_CHECKLIST_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const getApiErrorMessage = (error) => {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }

  return error ? Strings.network_error : null;
};

export const getJobShiftSwms = ({ jobId, shiftId, swmsId }, abortController = {}) => () => {
  if (!jobId || !shiftId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.get(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}`,
    { ...abortController }
  ).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(getApiErrorMessage(error)));
};
